let Backbone = require("backbone");
let _ = require("underscore");

let main  = function(){
    var tooieStatusService = {
        tooieStatus:null,
        _initialize:function(){
            this.tooieStatus = new Backbone.Model({"status":""})
        },
        statusModel:function(){
            return this.tooieStatus;
        }
    };
    tooieStatusService.initialize = _.once(tooieStatusService._initialize);
    return tooieStatusService;
};
let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/service/TooieStatusService.js